'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require('semantic-ui-react');

var _dyzioIcons = require('../../components/dyzio-icons');

var _formatting = require('../../utils/formatting');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = typeof window !== 'undefined' && window.location,
    hostname = _ref.hostname;

var headerStyle = {
  marginLeft: 170,
  marginRight: 170,
  paddingTop: 30
};

var VizzMediaKit = function VizzMediaKit(_ref2) {
  var influencer = _ref2.influencer,
      logoProps = _ref2.logoProps,
      avatarProps = _ref2.avatarProps;
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_semanticUiReact.Image, (0, _extends3.default)({ src: influencer.thumbnail }, avatarProps)),
    _react2.default.createElement(_semanticUiReact.Image, logoProps),
    _react2.default.createElement(
      'div',
      { style: headerStyle },
      _react2.default.createElement(
        _semanticUiReact.Header,
        { size: 'huge' },
        influencer.primarySocialHandle
      ),
      _react2.default.createElement(
        _semanticUiReact.Header,
        { size: 'large', color: 'grey' },
        influencer.name
      )
    ),
    _react2.default.createElement(_semanticUiReact.Divider, { clearing: true }),
    _react2.default.createElement(
      _semanticUiReact.Table,
      { basic: 'very', fixed: true, singleLine: true, textAlign: 'center' },
      _react2.default.createElement(
        _semanticUiReact.Table.Body,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            _react2.default.createElement(_dyzioIcons.YoutubeIcon, null),
            (0, _formatting.commaFormatted)(influencer.youtubeCount)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            _react2.default.createElement(_dyzioIcons.InstagramIcon, null),
            (0, _formatting.commaFormatted)(influencer.instagramCount)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            _react2.default.createElement(_dyzioIcons.TwitterIcon, null),
            (0, _formatting.commaFormatted)(influencer.twitterCount)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            _react2.default.createElement(_dyzioIcons.FacebookIcon, null),
            (0, _formatting.commaFormatted)(influencer.facebookCount)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            _react2.default.createElement(_dyzioIcons.TwitchIcon, null),
            (0, _formatting.commaFormatted)(influencer.twitchCount)
          )
        )
      )
    ),
    _react2.default.createElement(_semanticUiReact.Divider, null)
  );
};

exports.default = VizzMediaKit;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/media-kit-header/index.js
 ** module id = 2583
 ** module chunks = 0
 **/